$(document).ready(function() {
    let count = 1,productIdsArr = [],addOnUpgrades=[],
        customPrice, skipCount = 0,
        lensesResult = {
            lens_type: "Distance~Send Prescription Later",
            lensPackage: "",
            Upgrades: "",
            id: "",
            firstAddOnProductID: "",
            secondAddOnProductID: "",
            addOnProductID:"",
            additionalComment: "",
            prism:""
        };
    var prescriptionDetail = {
        right_od: {
            sphare: $('select[data-item="rightSphare"]').val(),
            cylinder: $('select[data-item="rightCylinder"]').val(),
            axis: $('select[data-item="rightAxis"]').val(),
            power: $('select[data-item="rightPower"]').val()
        },
        left_os: {
            sphare: $('select[data-item="leftSphare"]').val(),
            cylinder: $('select[data-item="leftCylinder"]').val(),
            axis: $('select[data-item="leftAxis"]').val(),
            power: $('select[data-item="leftPower"]').val()
        },
        pd: {
            left: $('select[data-item="pdLeft"]').val(),
            right: $('select[data-item="pdRight"]').val(),
          customPd: ""  
        }
    };
  var prismDetails = {
    od:{
      Vertical :$('select[data-item="od_vertical"]').val(),
      Vertical_Base_Direction:$('select[data-item="od_vertical_direction"]').val(),
      Horizontal :$('select[data-item="od_horizontal"]').val(),
      Horizontal_Base_Direction:$('select[data-item="od_horizontal_direction"]').val()
    },
    os:{
       Vertical :$('select[data-item="os_vertical"]').val(),
      Base_Direction:$('select[data-item="os_vertical_direction"]').val(),
      Horizontal :$('select[data-item="os_horizontal"]').val(),
      Horizontal_Base_Direction:$('select[data-item="os_horizontal_direction"]').val()
    }
  },transition = "",polarized="",prismProduct={},prescriptionSubmissionReference="",
    prismSurchargeApplied=false,prismSurchargePrice=0;

    function removeSecurePrismSurcharge() {
      if (!prismSurchargeApplied) return;
      let finalPrice = Number($(".tPrice").text()) - prismSurchargePrice,
          customAddOnPrice = Number($(".addedPrice").text()) - prismSurchargePrice;
      if (!isNaN(finalPrice)) $(".priceTitle,.tPrice").html(finalPrice.toFixed(2));
      if (!isNaN(customAddOnPrice)) $(".addedPrice").text(Math.max(0, customAddOnPrice).toFixed(2));
      prismSurchargeApplied = false;
      prismSurchargePrice = 0;
      prismProduct = {};
      lensesResult.prism = "";
      $(".result_prism").parents(".left-inner").attr("style", "display:none;");
    }

    function resetCartButton(message) {
      $(".loader").hide();
      $(".customAdd").show();
      $(".customAddToCart").prop("disabled", false).attr("aria-busy", "false");

      let errorMessage = $(".customCartError");
      if (!errorMessage.length) {
        errorMessage = $('<p class="customCartError" role="alert"></p>');
        $(".customAddToCart").after(errorMessage);
      }
      errorMessage.text(message).show();
    }

    function handleCartError(xhr, status, error) {
      console.error("Shopify cart request failed", {
        status: xhr && xhr.status,
        response: xhr && xhr.responseJSON,
        requestStatus: status,
        error: error
      });
      resetCartButton("We could not add these items to your cart. Please try again.");
    }

    function optionPrice(option) {
      let price = Number($(option).attr("data-price")) / 100;
      return Number.isFinite(price) ? price : 0;
    }

    function adjustDisplayedPrice(amount) {
      let totalPrice = Number($(".tPrice").text()),
          addOnPrice = Number($(".addedPrice").text());

      if (!Number.isFinite(totalPrice)) return;
      if (!Number.isFinite(addOnPrice)) addOnPrice = 0;

      totalPrice += amount;
      addOnPrice += amount;
      $(".addedPrice").text(Math.max(0, addOnPrice).toFixed(2));
      $(".priceTitle,.tPrice").html(totalPrice.toFixed(2));
      $(".addOnPrice,.TotalPrice").show();
    }

    function removeUpgradeSelection(upgrade) {
      let selectedUpgrade = $(upgrade);
      if (!selectedUpgrade.hasClass("active")) return;

      let productId = String(selectedUpgrade.attr("data-id")),
          upgradeName = selectedUpgrade.attr("data-item");

      selectedUpgrade.removeClass("active");
      productIdsArr = productIdsArr.filter(function(item) {
        return String(item.id) !== productId;
      });
      addOnUpgrades = addOnUpgrades.filter(function(item) {
        return item !== upgradeName;
      });
      adjustDisplayedPrice(-optionPrice(selectedUpgrade));
    }

    function clearUpgradeSelections() {
      $(".finalStep.active").each(function() {
        removeUpgradeSelection(this);
      });
      lensesResult.Upgrades = "";
    }

    function showLensStep(stepName) {
      let targetStep = $('.steps[current-step="' + stepName + '"]');
      if (!targetStep.length) return false;

      $(".steps").hide();
      targetStep.show();
      return true;
    }

    $("body").on("click", "[data-prescription-usage], .Non-prescription", function() {
      prescriptionSubmissionReference = "";
      removeSecurePrismSurcharge();
    });

    document.addEventListener("illusion:secure-prescription-complete", function(event) {
      let detail = event.detail || {},
          reference = detail.submissionReference,
          prismVariantId = String(detail.prismVariantId || ""),
          prismPrice = Number(detail.prismPrice || 0) / 100;
      if (!/^rx_[A-Za-z0-9_-]{32,61}$/.test(reference || "")) return;

      removeSecurePrismSurcharge();
      prescriptionSubmissionReference = reference;
      count = 0;
      lensesResult.lens_type = "Secure prescription provided";
      lensesResult.additionalComment = "";
      $(".PRESCRIPTION").addClass("customActive");

      if (detail.prismSurcharge === true && /^[0-9]{1,32}$/.test(prismVariantId)) {
        let finalPrice = Number($(".tPrice").text()) + prismPrice,
            customAddOnPrice = Number($(".addedPrice").text()) + prismPrice;
        if (!isNaN(finalPrice)) $(".priceTitle,.tPrice").html(finalPrice.toFixed(2));
        if (!isNaN(customAddOnPrice)) $(".addedPrice").text(customAddOnPrice.toFixed(2));
        $(".addOnPrice,.TotalPrice").show();
        lensesResult.prism = `Prism $${prismPrice.toFixed(2)}`;
        $(".result_prism").parents(".left-inner").attr("style", "display:flex;");
        prismProduct = {
          quantity: 1,
          id: prismVariantId,
          properties: { _addOns: lensesResult.id }
        };
        prismSurchargeApplied = true;
        prismSurchargePrice = prismPrice;
      }

      $("[data-secure-prescription-step]").hide();
      $('.steps[current-step="lenseThickness"]').show()
        .children(".back").attr("previousStep", "chooseOutline");
    });
    $(".customLens").click(function() {
        let id = $("input[name=id]").val();
        lensesResult.id = id, $(".customMainImage").attr("style", "display:block"),
          $(".Modal_Popup").show(), $("body").toggleClass("LensPOP-open")
    }), $("body").on("click", ".customTrigger", function() {
        if($(this).attr("data-handle")){
          let dataHandle = $(this).attr("data-handle");
          $(".customAddOns").hide();
          $(`.customAddOns[data-name="${dataHandle}"]`).show();
        }
        if($("#terms-and-conditions").prop("checked") == false && $(this).hasClass("terms")){
          $("#terms-and-conditions").siblings("label").attr("style","color:#ff0000");
          return ;
          // PD Validation

        }

        if ($(this).hasClass("terms")) {

  if ($("#pd").is(":checked")) {

    const leftPd = $('select[data-item="pdLeft"]').val();
    const rightPd = $('select[data-item="pdRight"]').val();

    if (!leftPd || leftPd == "0" || !rightPd || rightPd == "0") {
      alert("Please select both Left and Right PD.");
      return;
    }

  } else {

    const singlePd = $('select[data-item="customPd"]').val();

    if (!singlePd || singlePd == "0") {
      alert("Please select PD.");
      return;
    }

  }
}
        // if($("#pd").prop("checked") == false){
        //   $("#pd").siblings("label").attr("style","color:#ff0000");
        //   return ;
        // }
        $("#terms-and-conditions").siblings("label").attr("style","color:#121212BF");
        $(this).parents(".steps").hide();
        let currentStep = $(this).parents(".steps").attr("current-step"),
            nextStep = $(this).attr("next-step"),
            send_later = $(this).attr("data-id"),
            additionalComment = $("#additionalComment").val(),
            continueWithPrescription = $(this).attr("data-id-continue");
        if (send_later != null && ($(".PRESCRIPTION").addClass("customActive"), count = 1, lensesResult.lens_type = "Distance~Send Prescription Later", continueWithPrescription = void 0), continueWithPrescription != null) {
            count = 0, $(".PRESCRIPTION").addClass("customActive");
            let customerId = $(".customID").children("input").attr("customerId");
            $("#prescription").is(":checked") == !0 && saveData(customerId, prescriptionDetail), lensesResult.lens_type = "Distance~View Prescription", send_later = void 0, lensesResult.additionalComment = additionalComment
        }
        if (currentStep == "chooseGlass") {
          $('.steps[current-step="lenseThickness"]').attr("glassType", "Presscription");
        }
        $(`.steps[current-step=${nextStep}]`).show(), $(`.steps[current-step=${nextStep}]`).children(".back").attr("previousStep", currentStep), console.log(currentStep, nextStep)
    }), $("body").on("click", ".customTriggerNonPress", function() {
        $(this).parents(".steps").hide();
        if($(this).attr("data-handle")){
          let dataHandle = $(this).attr("data-handle");
          $(".customAddOns").hide();
          $(`.customAddOns[data-name="${dataHandle}"]`).show();
        }
        let currentStep = $(this).parents(".steps").attr("current-step"),
            nextStep = $(this).attr("next-step"),
            isNonPrescription = $(this).hasClass("Non-prescription");
        $('.steps[current-step="lenseThickness"]').attr(
          "glassType",
          isNonPrescription ? "NonPresscription" : "Presscription"
        );
        $(`.steps[current-step=${nextStep}]`).show(), $(`.steps[current-step=${nextStep}]`).children(".back").attr("previousStep", currentStep)
    }), $("body").on("click", "#prescription", function() {
        let customIdSelected = $(this).is(":checked"),
            emailStatus = $(".customID").text();
        customIdSelected == !1 && emailStatus == "" ? ($("#customID").hide(), $(".Modal_Popup2").attr("style", "display:none!important")) : ($("#customID").hide(), $(".Modal_Popup2").attr("style", "display:block!important"))
    }), $("body").on("click", ".back", function(event) {
        event.preventDefault();
        let previousStep = $(this).attr("previousStep");

        if (!showLensStep(previousStep)) return;
        if (previousStep == "chooseOutline") {
          document.dispatchEvent(new CustomEvent("illusion:secure-prescription-edit"));
        }
    }), $("body").on("click", ".customAddOns", function() {
        transition = $(this).attr("data-transition-id") || "";
        polarized = $(this).attr("data-polarized-id") || "";
        console.log(transition,polarized);
        let previousSelection = $(".customAddOns.active").first(),
            priceDifference = optionPrice(this) - (previousSelection.length ? optionPrice(previousSelection) : 0);
        $(".customAddOns").removeClass("active");
        $(this).addClass("active");
        adjustDisplayedPrice(priceDifference);
        let variantId = $(this).attr("data-id");
        lensesResult.firstAddOnProductID = variantId;
        let lensPackage = $(this).attr("data-item");
        lensesResult.lensPackage = lensPackage, $(this).parents(".steps").attr("glassType") != "NonPresscription" ? ($(this).parents(".steps").hide(), $(this).parents(".steps").siblings(".step5").show(), console.log(lensesResult)) : (count = 2, $(this).parents(".steps").hide(), $('.steps[current-step="lensType"]').show(), $('.steps[current-step="lensType"]').children(".back").attr("previousStep", "lenseThickness"))
    }), $("body").on("click", ".fileContinue", function() {
        $(".PRESCRIPTION").addClass("customActive");
        let imgUrl = $("#fileUpload")[0].files[0],
            currentStep = $(this).parents(".steps").attr("current-step"),
            nextStep = $(this).attr("next-step");
        lensesResult.lens_type = "Distance Prescription uploaded~", $(this).parents(".steps").hide(), $(`.steps[current-step=${nextStep}]`).show(), $(`.steps[current-step=${nextStep}]`).children(".back").attr("previousStep", currentStep), console.log(lensesResult)
    }),
    
$('#pd').prop('checked', false);

$('select[data-item="customPd"]').val("0");
$('select[data-item="pdLeft"]').val("0");
$('select[data-item="pdRight"]').val("0");

$(".customPd").parent("td").show();
$("select[data-item=pdRight],select[data-item=pdLeft]").parent("td").hide();

    $("body").on("click", "#pd", function() {
         $(this).is(":checked") ? (prescriptionDetail.pd.left=$('select[data-item="pdLeft"]').val(),prescriptionDetail.pd.right=$('select[data-item="pdRight"]').val(),prescriptionDetail.pd.customPd="",$("select[data-item=pdRight],select[data-item=pdLeft]").parent("td").show(), $(".customPd").parent("td").hide()) : (prescriptionDetail.pd.left="",prescriptionDetail.pd.right="",prescriptionDetail.pd.customPd=$('select[data-item="customPd"]').val(),$(".customPd").parent("td").show(), $("select[data-item=pdRight],select[data-item=pdLeft]").parent("td").hide())
    }), $("body").on("click", ".finalStep_continue", function() {
        if(productIdsArr.length <= 0){
          $(".finalStep").addClass("shake");
          setTimeout(() => {
              $(".finalStep").removeClass("shake");
          }, 500);
          return ;
        }
        skipCount = 0, $(".framePrice").html($(".customPrice").children("p").text()), $(".upgradeTitle").parents(".border-bottom").show();
        lensesResult.Upgrades = addOnUpgrades.join(', ');
        $(".Result .back").attr("previousStep", "availableCoatings");
        $(this).parents(".steps").hide();
        $(".frameTitle").html(lensesResult.title);
        $(".lensTitle").html(lensesResult.lensPackage);
        $(".upgradeTitle").html(lensesResult.Upgrades);
        $(".result_prism").html(lensesResult.prism);
        $(".customPrice").html(lensesResult.price);
        $(".Result").show();
          console.log(lensesResult,productIdsArr)
    }).on('click','.finalStep',function(){
        
        let productId = $(this).attr('data-id');
        let upgrade = $(this).attr('data-item');
        if($(this).hasClass("active") == true){
          $(this).removeClass("active");
          $(this).find(".prescription-option-button").attr("aria-pressed", "false");
          productIdsArr = productIdsArr.filter(item => item.id !== productId); 
          addOnUpgrades = addOnUpgrades.filter(item=> item !== upgrade)
          let finalPrice = Number($(".tPrice").text()) - Number($(this).attr("data-price")/100),
          customAddOnPrice = Number($(".addedPrice").text()) - Number($(this).attr("data-price")/100);
          $(".addedPrice").text(customAddOnPrice.toFixed(2)), $(".priceTitle,.tPrice").html(finalPrice.toFixed(2));
        }else{
          if($(".finalStep.active[data-name='transitions'][data-selection-type='0']").length > 0 || $(".finalStep.active[data-name='sunglasses'][data-selection-type='0']").length > 0){
            if($(this).attr("data-selection-type") == 0){
              alert("You can select only one item!");
              return;
            }
          }
          
          $(this).addClass("active");
          $(this).find(".prescription-option-button").attr("aria-pressed", "true");
          productIdsArr.push({id:productId,quantity:1,properties:{_addOns:lensesResult.id}});
          addOnUpgrades.push(upgrade);
          let finalPrice = Number($(".tPrice").text()) + Number($(this).attr("data-price")/100),
          customAddOnPrice = Number($(".addedPrice").text()) + Number($(this).attr("data-price")/100);
          $(".addedPrice").text(customAddOnPrice.toFixed(2)), $(".priceTitle,.tPrice").html(finalPrice.toFixed(2));
        }   
    }), $("body").on("click", ".skipStep", function() {
        let currentStep = $(this).parents(".steps").attr("current-step");
        if (currentStep == "availableCoatings") {
          clearUpgradeSelections();
        } else if (currentStep == "lensType") {
          let selectedLensType = $(".customAddOnsLensType.active").first();
          if (selectedLensType.length) adjustDisplayedPrice(-optionPrice(selectedLensType));
          $(".customAddOnsLensType").removeClass("active");
          lensesResult.secondAddOnProductID = "";
          clearUpgradeSelections();
        }
        $(".Result .back").attr("previousStep", currentStep);
        $(".framePrice").html($(".customPrice").children("p").text()), lensesResult.Upgrades = "", skipCount = 1, $(".priceTitle").html($(".tPrice").text()), $(this).parents(".steps").hide(), $(".frameTitle").html(lensesResult.title), $(".lensTitle").html(lensesResult.lensPackage), $(".upgradeTitle").parents(".border-bottom").hide(), $(".customPrice").html(lensesResult.price), $(".Result").show()
    }), $("body").on("change", "select", function() {
        let currentStatus = $(this).attr("data-item"),
            currentValue = $(this).val();
        switch (currentStatus) {
            case "rightSphare":
                prescriptionDetail.right_od.sphare = currentValue;
                break;
            case "rightCylinder":
                prescriptionDetail.right_od.cylinder = currentValue;
                break;
            case "rightAxis":
                prescriptionDetail.right_od.axis = currentValue;
                break;
            case "rightPower":
                prescriptionDetail.right_od.power = currentValue;
                break;
            case "leftSphare":
                prescriptionDetail.left_os.sphare = currentValue;
                break;
            case "leftCylinder":
                prescriptionDetail.left_os.cylinder = currentValue;
                break;
            case "leftAxis":
                prescriptionDetail.left_os.axis = currentValue;
                break;
            case "leftPower":
                prescriptionDetail.left_os.power = currentValue;
                break;
            case "pdLeft":
                prescriptionDetail.pd.left = currentValue;
                break;
            case "pdRight":
                prescriptionDetail.pd.right = currentValue;
                break;
            case "customPd":
                prescriptionDetail.pd.customPd = currentValue;
                break;
            case "od_vertical":
                prismDetails.od.Vertical = currentValue;
                break;
            case "od_vertical_direction":
                prismDetails.od.Vertical_Base_Direction = currentValue;
                break;
            case "od_horizontal":
                prismDetails.od.Horizontal = currentValue;
                break;
            case "od_horizontal_direction":
                prismDetails.od.Horizontal_Base_Direction = currentValue;
                break;
            case "os_vertical":
                prismDetails.os.Vertical = currentValue;
                break;
            case "os_vertical_direction":
                prismDetails.os.Vertical_Base_Direction = currentValue;
                break;
            case "os_horizontal":
                prismDetails.os.Horizontal = currentValue;
                break;
            case "os_horizontal_direction":
                prismDetails.os.Horizontal_Base_Direction = currentValue;
                break;
            default:
                break;
        }
    }), $("body").on("click", ".customClose", function() {
        $("#prescription").parent("div").show(), $("#prescription").prop("checked", !1), $(".Modal_Popup2").attr("style", "none:block!important")
    }), $("body").on("click", ".editThikness", function() {
        $(this).parents(".Result").hide(), $(".steps[current-step=lenseThickness]").show()
    }), $("body").on("click", ".customAddToCart", function() {
        if ($(this).prop("disabled")) return;
        $(this).prop("disabled", true).attr("aria-busy", "true");
        $(".customCartError").hide();
        $(".loader").show(), $(".customAdd").hide(), console.log(count);
        let variant_id = lensesResult.id,
            formData = new FormData;
        formData.append("id", variant_id), formData.append("quantity", 1);
        if (count == 0) {
          if (!/^rx_[A-Za-z0-9_-]{32,61}$/.test(prescriptionSubmissionReference)) {
            resetCartButton("Your prescription session is missing. Please return to the prescription step and submit it again.");
            return;
          }
          formData.append("properties[_Prescription Reference]", prescriptionSubmissionReference);
          formData.append("properties[_Lens Type]", lensesResult.lens_type);
          formData.append("properties[_Lens Package]", lensesResult.lensPackage);
          formData.append("properties[_Upgrades]", lensesResult.Upgrades);
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            processData: !1,
            contentType: !1,
            dataType: "json",
            timeout: 20000,
            success: function(data) {
                addToCart(), console.log(data)
            },
            error: handleCartError
          });
        } else if (count == 2) {
          formData.append("properties[_Lens Package]", lensesResult.lensPackage);
          formData.append("properties[_Upgrades]", lensesResult.Upgrades);
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            processData: !1,
            contentType: !1,
            dataType: "json",
            timeout: 20000,
            success: function(data) {
                addToCart(), console.log(data)
            },
            error: handleCartError
          });
        } else {
          finalAddToCart(variant_id, formData);
        }
    }).on("click","#prism",function(){
      if($(this).prop("checked")){
        let finalPrice = Number($(".tPrice").text()) + Number($(this).attr("data-price")/100),
            customAddOnPrice = Number($(".addedPrice").text()) + Number($(this).attr("data-price")/100);
        $(".addedPrice").text(customAddOnPrice.toFixed(2)), $(".priceTitle,.tPrice").html(finalPrice.toFixed(2)), $(".addOnPrice,.TotalPrice").show(), $(".LENS").addClass("customActive");
        $(".prism_table").removeClass("hidden");
          lensesResult.prism = `Prism $${$(this).attr("data-price")/100}`;
          $(".result_prism").parents(".left-inner").attr("style","display:flex;");
      }else{
        let finalPrice = Number($(".tPrice").text()) - Number($(this).attr("data-price")/100),
            customAddOnPrice = Number($(".addedPrice").text()) - Number($(this).attr("data-price")/100);
        $(".addedPrice").text(customAddOnPrice.toFixed(2)), $(".priceTitle,.tPrice").html(finalPrice.toFixed(2)), $(".addOnPrice,.TotalPrice").show(), $(".LENS").addClass("customActive");
        lensesResult.prism = "";
        $(".result_prism").parents(".left-inner").attr("style","display:none;");
        $("#fileUpload").val("");
        $(".customFileUpload").attr("style","display:flex;");
        $(".customShowImage").attr("style","display:none;");
        // $(".upload_prism_img").addClass("hidden");
        $(".prism_table").addClass("hidden");
      }
    }).on("click", ".variant_color input, .variant_color label", function(event) {
      event.stopPropagation();
    }).on("change", ".variant_color input[type='radio']", function() {
      let selectedInput = $(this),
          colorGroup = selectedInput.closest(".variant_color"),
          selectedLabel = selectedInput.next("label"),
          finalStep = selectedInput.closest(".finalStep"),
          previousProductId = finalStep.attr("data-id"),
          selectedProductId = selectedInput.val();

      colorGroup.find("label").removeClass("active");
      selectedLabel.addClass("active");
      selectedInput.closest(".content").find(".color_name").text(` ${selectedLabel.attr("data-title")}`);
      finalStep.attr("data-id", selectedProductId);

      if (finalStep.hasClass("active")) {
        productIdsArr.forEach(function(item) {
          if (String(item.id) === String(previousProductId)) {
            item.id = selectedProductId;
          }
        });
      }
    });

    $("body").on("click", ".customAddOnsLensType", function() {
        let previousSelection = $(".customAddOnsLensType.active").first(),
            selectionChanged = previousSelection.length
              && String(previousSelection.attr("data-id")) !== String($(this).attr("data-id")),
            priceDifference = optionPrice(this) - (previousSelection.length ? optionPrice(previousSelection) : 0);

        if (selectionChanged) clearUpgradeSelections();
        console.log(transition,$(this).attr("data-name"));
        $(".customAddOnsLensType").removeClass("active");
        $(this).addClass("active");
        adjustDisplayedPrice(priceDifference);
        $(".LENS").addClass("customActive");
        let variantId = $(this).attr("data-id"),
            isFreeTransitionHelper = $(this).attr("data-name") == "transitions"
              && Number($(this).attr("data-price")) === 0;
        lensesResult.secondAddOnProductID = isFreeTransitionHelper ? "" : variantId;
        let lensPackage = $(this).attr("data-item");
        $(".dataHeading").text($(`.finalStep[data-name='${$(this).attr("data-name")}']`).attr("data-heading"));
        $(".finalStep").hide();
        $(`.finalStep[data-name='${$(this).attr("data-name")}']`).show();
        if($(this).attr("data-name") == "transitions" && transition.length > 0){
          $(".finalStep").hide();
          if(typeof transition === "string"){
            transition = transition.split(",");
          }
          for(let transitionName of transition){
            console.log(transitionName,`.finalStep.${transitionName.trim()}`,$(`.finalStep.${transitionName.trim()}[data-name="${$(this).attr("data-name")}"]`));
            $(`.finalStep.${transitionName.trim()}[data-name="${$(this).attr("data-name")}"]`).show();
          }
        }
        if($(this).attr("data-name") == "sunglasses" && polarized.length > 0){
          $(".finalStep").hide();
          polarized = polarized.split(",");
          for(let polarizedName of polarized){
            console.log(polarizedName);
            $(`.finalStep.${polarizedName.trim()}`).show();
          }
        }
        $(this).parents(".steps").attr("glassType") != "NonPresscription" ? ($(this).parents(".steps").hide(), $(this).parents(".steps").siblings(".step6").show(), console.log(lensesResult)) : (count = 2, $(this).parents(".steps").hide(), $('.steps[current-step="lensType"]').show(), $('.steps[current-step="lensType"]').children(".back").attr("previousStep", "lenseThickness"))
    })

    function finalAddToCart(variant_id, formData) {
        formData.append("properties[_Lens Type]", lensesResult.lens_type), formData.append("properties[_Lens Package]", lensesResult.lensPackage), formData.append("properties[_Upgrades]", lensesResult.Upgrades), $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: formData,
            processData: !1,
            contentType: !1,
            dataType: "json",
            timeout: 20000,
            success: function(data) {
                addToCart(), console.log(data)
            },
            error: handleCartError
        })
    }

    async function removeFreeSunglassesFromCart() {
        const root = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : "/";

        const cartResponse = await fetch(root + "cart.js", {
            headers: { "Accept": "application/json" }
        });

        if (!cartResponse.ok) {
            throw new Error("Could not read the cart");
        }

        const cart = await cartResponse.json();
        const freeSunglasses = cart.items.filter(function(item) {
            const title = String(item.product_title || "").trim().toLowerCase();
            const price = Number(
                item.original_price !== undefined
                    ? item.original_price
                    : item.price
            );

            return title === "sunglasses" && price === 0;
        });

        for (const item of freeSunglasses) {
            const removeResponse = await fetch(root + "cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                })
            });

            if (!removeResponse.ok) {
                throw new Error("Could not remove free Sunglasses item");
            }
        }

        console.log("FREE-SUNGLASSES-CLEANUP-RAN", freeSunglasses.length);
    }

    function addToCart() {
        let data;

        if (lensesResult.secondAddOnProductID != "") {
            data = {
                items: [
                    {
                        quantity: 1,
                        id: lensesResult.firstAddOnProductID,
                        properties: {
                            _addOns: lensesResult.id
                        }
                    },
                    {
                        quantity: 1,
                        id: lensesResult.secondAddOnProductID,
                        properties: {
                            _addOns: lensesResult.id
                        }
                    }
                ]
            };
        } else {
            data = {
                items: [
                    {
                        quantity: 1,
                        id: lensesResult.firstAddOnProductID,
                        properties: {
                            _addOns: lensesResult.id
                        }
                    }
                ]
            };
        }

        if (prismProduct.id) {
            data.items.push(prismProduct);
        }

        productIdsArr.forEach(function(item) {
            data.items.push(item);
        });

        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            timeout: 20000,
            success: function() {
                removeFreeSunglassesFromCart()
                    .catch(function(error) {
                        console.error("Sunglasses cleanup error:", error);
                    })
                    .finally(function() {
                        window.location.href = "/cart";
                    });
            },
            error: handleCartError
        });
    }

    function saveData(customerId, prescriptionDetail2) {
        let customerEmail = $(".customID").attr("customeremail");
    }
});

function readURL(input) {
    if ($(".customFileUpload").hide(), $(".customShowImage").show(), input.files && input.files[0]) {
        var reader = new FileReader;
        reader.onload = function(e) {
            $("#blah").attr("src", e.target.result).width(150).height(200)
        }, reader.readAsDataURL(input.files[0])
    }
}
//# sourceMappingURL=/cdn/shop/t/44/assets/custom.js.map?v=179378555672175653101704360363
